import axios from "./Axios";
import {
  FETCH_FORM_TYPES_SUCCESS,
  FETCH_FORM_TYPES_FAIL,
  CREATE_FORM_INSTANCE_SUCCESS,
  CREATE_FORM_INSTANCE_FAIL,
  FETCH_FORM_STRUCTURE_SUCCESS,
  FETCH_FORM_STRUCTURE_FAIL,
  ADD_FORM_INSTANCE_ID_TO_REDUX,
  FORM_ENTRY_ADDED_SUCCESS,
  FORM_ENTRY_ADDED_FAIL,
  RESET_FORM_REDUX_STATE,
  FORM_ENTRY_RENDERED_SUCCESS,
  FORM_ENTRY_RENDERED_FAIL,
  FETCH_PDF_TEMPLATES_SUCCESS,
  FETCH_PDF_TEMPLATES_FAIL,
  UPLOAD_PDF_TEMPLATE_SUCCESS,
  UPLOAD_PDF_TEMPLATE_FAIL,
  DELETE_PDF_TEMPLATE_SUCCESS,
  DELETE_PDF_TEMPLATE_FAIL,
  SET_ACTIVE_PDF_TEMPLATE,
  SAVE_PDF_TEMPLATE_FIELDS_SUCCESS,
  SAVE_PDF_TEMPLATE_FIELDS_FAIL,
  CREATE_PDF_TEMPLATE_INSTANCE_SUCCESS,
  CREATE_PDF_TEMPLATE_INSTANCE_FAIL,
  UPDATE_PDF_TEMPLATE_INSTANCE_SUCCESS,
  UPDATE_PDF_TEMPLATE_INSTANCE_FAIL,
  RENDER_PDF_TEMPLATE_INSTANCE_SUCCESS,
  RENDER_PDF_TEMPLATE_INSTANCE_FAIL,
  RESET_PDF_TEMPLATE_STATE,
} from "./Types";
import { returnErrors } from "./Errors";

export const FetchFormTypesAction = () => async (dispatch) => {
  try {
    const res = await axios.get("/api/form/forms/available/");

    dispatch({
      type: FETCH_FORM_TYPES_SUCCESS,
      payload: res.data,
    });
    return res.data;
  } catch (err) {
    dispatch(returnErrors(err.response?.data, err.response?.status));

    dispatch({
      type: FETCH_FORM_TYPES_FAIL,
    });

    throw err;
  }
};

export const CreateFormInstanceAction = (formType) => async (dispatch) => {
  try {
    const res = await axios.post(`/api/form/forms/${formType}/`);

    dispatch({
      type: CREATE_FORM_INSTANCE_SUCCESS,
      payload: res.data,
    });
    return res.data;
  } catch (err) {
    dispatch(returnErrors(err.response?.data, err.response?.status));
    dispatch({
      type: CREATE_FORM_INSTANCE_FAIL,
    });
    throw err;
  }
};

export const FetchFormStructureAction = (formInstance) => async (dispatch) => {
  try {
    const res = await axios.get(
      `/api/form/form-instances/${formInstance}/fetch-form-structure/`
    );
    dispatch({
      type: FETCH_FORM_STRUCTURE_SUCCESS,
      payload: res.data,
    });
    return res.data;
  } catch (err) {
    dispatch(returnErrors(err.response?.data, err.response?.status));
    dispatch({
      type: FETCH_FORM_STRUCTURE_FAIL,
    });
    throw err;
  }
};

export const AddFormInstanceIDToReduxAction = (id, name) => {
  return {
    type: ADD_FORM_INSTANCE_ID_TO_REDUX,
    payload: { id, name },
  };
};

export const UpdateFormInstanceAction =
  (formInstance, data) => async (dispatch) => {
    try {
      const res = await axios.put(
        `/api/form/form-instances/${formInstance}/update/`,
        data
      );
      dispatch({
        type: FORM_ENTRY_ADDED_SUCCESS,
        payload: res.data,
      });
      return res.data;
    } catch (err) {
      dispatch(returnErrors(err.response?.data, err.response?.status));
      dispatch({
        type: FORM_ENTRY_ADDED_FAIL,
      });
      throw err;
    }
  };

export const ResetFormReduxStateAction = () => {
  return {
    type: RESET_FORM_REDUX_STATE,
  };
};

export const RenderForm = (id) => async (dispatch) => {
  try {
    const res = await axios.get(`/api/form/form-instances/${id}/render/`);

    dispatch({
      type: FORM_ENTRY_RENDERED_SUCCESS,
      payload: res.data,
    });
  } catch (err) {
    dispatch(returnErrors(err.response?.data, err.response?.status));

    dispatch({
      type: FORM_ENTRY_RENDERED_FAIL,
    });
    throw err;
  }
};

export const SaveFormInstanceAsPDF = (id) => async (dispatch) => {
  try {
    const res = await axios.get(`/api/form/form-instances/${id}/render/pdf/`);
    dispatch({
      type: FORM_ENTRY_RENDERED_SUCCESS,
      payload: res.data,
    });
  } catch (err) {
    dispatch(returnErrors(err.response?.data, err.response?.status));
    dispatch({
      type: FORM_ENTRY_RENDERED_FAIL,
    });
    throw err;
  }
};

// ─── PDF Template Actions ─────────────────────────────────────────────────────

export const FetchPDFTemplatesAction = () => async (dispatch) => {
  try {
    const res = await axios.get("/api/form/pdf-templates/");
    dispatch({ type: FETCH_PDF_TEMPLATES_SUCCESS, payload: res.data });
    return res.data;
  } catch (err) {
    dispatch(returnErrors(err.response?.data, err.response?.status));
    dispatch({ type: FETCH_PDF_TEMPLATES_FAIL });
    throw err;
  }
};

export const UploadPDFTemplateAction = (formData) => async (dispatch) => {
  try {
    const res = await axios.post("/api/form/pdf-templates/upload/", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    dispatch({ type: UPLOAD_PDF_TEMPLATE_SUCCESS, payload: res.data });
    return res.data;
  } catch (err) {
    dispatch(returnErrors(err.response?.data, err.response?.status));
    dispatch({ type: UPLOAD_PDF_TEMPLATE_FAIL });
    throw err;
  }
};

export const SetActivePDFTemplateAction = (template) => ({
  type: SET_ACTIVE_PDF_TEMPLATE,
  payload: template,
});

export const DeletePDFTemplateAction = (id) => async (dispatch) => {
  try {
    await axios.delete(`/api/form/pdf-templates/${id}/`);
    dispatch({ type: DELETE_PDF_TEMPLATE_SUCCESS, payload: id });
    return id;
  } catch (err) {
    dispatch(returnErrors(err.response?.data, err.response?.status));
    dispatch({ type: DELETE_PDF_TEMPLATE_FAIL });
    throw err;
  }
};

export const SavePDFTemplateFieldsAction = (id, fields) => async (dispatch) => {
  try {
    const res = await axios.put(`/api/form/pdf-templates/${id}/fields/`, { fields });
    dispatch({ type: SAVE_PDF_TEMPLATE_FIELDS_SUCCESS, payload: res.data });
    return res.data;
  } catch (err) {
    dispatch(returnErrors(err.response?.data, err.response?.status));
    dispatch({ type: SAVE_PDF_TEMPLATE_FIELDS_FAIL });
    throw err;
  }
};

export const FetchPDFTemplateInstancesAction = (templateId) => async (dispatch) => {
  try {
    const res = await axios.get(`/api/form/pdf-templates/${templateId}/instances/`);
    dispatch({ type: 'FETCH_PDF_TEMPLATE_INSTANCES_SUCCESS', payload: res.data });
    return res.data;
  } catch (err) {
    dispatch(returnErrors(err.response?.data, err.response?.status));
    throw err;
  }
};

export const CreatePDFTemplateInstanceAction = (templateId) => async (dispatch) => {
  try {
    const res = await axios.post(`/api/form/pdf-templates/${templateId}/instances/create/`);
    dispatch({ type: CREATE_PDF_TEMPLATE_INSTANCE_SUCCESS, payload: res.data });
    return res.data;
  } catch (err) {
    dispatch(returnErrors(err.response?.data, err.response?.status));
    dispatch({ type: CREATE_PDF_TEMPLATE_INSTANCE_FAIL });
    throw err;
  }
};

export const UpdatePDFTemplateInstanceAction = (instanceId, values) => async (dispatch) => {
  try {
    const res = await axios.put(`/api/form/pdf-template-instances/${instanceId}/`, { values });
    dispatch({ type: UPDATE_PDF_TEMPLATE_INSTANCE_SUCCESS, payload: res.data });
    return res.data;
  } catch (err) {
    dispatch(returnErrors(err.response?.data, err.response?.status));
    dispatch({ type: UPDATE_PDF_TEMPLATE_INSTANCE_FAIL });
    throw err;
  }
};

export const RenderPDFTemplateInstanceAction = (instanceId) => async (dispatch) => {
  try {
    const res = await axios.get(`/api/form/pdf-template-instances/${instanceId}/render/`);
    dispatch({ type: RENDER_PDF_TEMPLATE_INSTANCE_SUCCESS, payload: res.data });
    return res.data;
  } catch (err) {
    dispatch(returnErrors(err.response?.data, err.response?.status));
    dispatch({ type: RENDER_PDF_TEMPLATE_INSTANCE_FAIL });
    throw err;
  }
};

export const ResetPDFTemplateStateAction = () => ({ type: RESET_PDF_TEMPLATE_STATE });
